//
// ===== File globals.ts
//
'use strict';

export const componentRolesList = [
    { name: 'ApplicationServer', displayName: 'Application Server' },
    { name: 'R2I', displayName: 'R2I' },
    { name: 'WS32', displayName: 'WS32' },
    { name: 'WS64', displayName: 'WS64' },
    { name: 'Client', displayName: 'Client' },
    { name: 'Chat', displayName: 'Chat' },
    { name: 'RisPacsIntegration', displayName: 'RisPacsIntegration' },
    { name: 'RisServices', displayName: 'RisServices' },
    { name: 'RisAgent', displayName: 'RisAgent' },
    { name: 'RisEnterpriseManager', displayName: 'RisEnterpriseManager' },
    { name: 'AuthenticationService', displayName: 'AuthenticationService' },
    { name: 'RisWeb', displayName: 'RisWeb' },
    { name: 'RisWebClient', displayName: 'RisWebClient' },
    { name: 'PatientPortal', displayName: 'PatientPortal' }

];


export const componentsPermissions =
    {
        'RisMonitoringScriptsResultsComponent': 'RisEnterpriseManager.Tabs.MonitoringScripts',
        'RisMonitoringScriptsComponent': 'RisEnterpriseManager.Tabs.MonitoringScripts',
        'LogManagerComponent': 'RisEnterpriseManager.Tabs.LogsAndUploadLogs',
        'UploadLogFilesComponent': 'RisEnterpriseManager.Tabs.LogsAndUploadLogs',
        'PatientPortalComponent': 'RisEnterpriseManager.Tabs.PatientPortal',
        'PatientKioskComponent': 'RisEnterpriseManager.Tabs.PatientKiosk'
    };
